











// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import Edit from '@/components/compte/edit/EditFamille.vue'
import ReadMembres from '@/components/compte/read/ReadMembres.vue'
import { getDefaultAloUser, AloUser } from '@/models/alo/AloUser'

@Component({
  name: 'ReadFamille',    
   props: {
    user:{      
      default:getDefaultAloUser()
    },
    loading:{
      type:Boolean,
      default:false
    }
  },
  components:{Edit,ReadMembres}
})
export default class ReadFamille extends Vue {
  private user!:AloUser
  private loading!:boolean

  get configuration(){
    return this.$store.myGetters.configuration
  }

  get mainAccount() {
    return this.user.membres.find(m => m?.actId == this.user?.famActId)
  }

  edit() { (this.$refs.edit as Edit).edit(this.user) }
}
